import { apiCall, ApiConfig } from '../../config/api'
import { getSubZonesAction } from '../actions/subzoneActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { GET_SUBZONES } from '../types/subzoneActionsTypes'
import { DataGridElements, SubZone } from '../../interfaces/index'

export function* getSubZonesAsync() {
  try {
    const { status, data }: AxiosResponse<DataGridElements<SubZone>> =
      yield call(apiCall, 'GET', `${ApiConfig.SubZoneApi}?pageSize=100`)
    if (status === 200) {
      yield put(getSubZonesAction(data.items))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getSubZonesAction([], serverError.message))
  }
}

export function* watchGetSubZonesAsync() {
  yield takeEvery(GET_SUBZONES, getSubZonesAsync)
}
